import {
  LOAD_PROJECT_LIST_SUCCESS,
  SAVE_PROJECT_ID,
} from "constants/ActionTypes";

class Project {
  constructor(nome, data) {
    this.nome = nome;
    this.data = data;
  }
}

const INIT_STATE = {
  myProjectList: [],
  selectedProjectID: localStorage.getItem('project_id'),
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {


    case LOAD_PROJECT_LIST_SUCCESS: {
      return {
        ...state,
        myProjectList: action.payload
      }
    }

    case SAVE_PROJECT_ID: {

      console.log("######## REDUCER - SELECTED PROJECT ID: "+ action.payload);
      return {
        ...state,
        selectedProjectID: action.payload
      }
    }

    default: {// need this for default case
       return state
    }

  }

}
